export const environment = {
  version: '<#package_version>',
  production: true,
  apiUrl: 'https://api.deopesca.com/',
  sentryDSN: 'https://7206108ab99b4dc29023241b87e3da1f@sentry.rvlio.com/4',
  cuotaAlertPercent: 80,
  maxExportRecords: 65536,
  datepickerConfig: {
    firstDayOfWeek: 1,
    dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
    dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
    monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts